export const lightgray = `#f4f4f4`
export const darkgray = `#808080`
export const lightblue = `#b4c8ed`

// export const color1 = `#2a637f`
// export const color2 = `#ffc101`
export const color1 = `black` 
export const color2 = `white`
export const highlight = `blue`